import { createContext, useContext, useState, useEffect } from "react"
import { locationsService } from "../services/locationsService"
import { useNavigate } from "react-router"
import { useUtiles } from "./utilesContext"
import * as XLSX from 'xlsx'
import Swal from 'sweetalert2'
const LocationsContext = createContext()

export const useLocations = () => {
    return useContext(LocationsContext)
}




export const LocationsProvider = ({children}) => {
    const [locations, setLocations] = useState([])
    const [locationsOptions, setLocationsOptions] = useState([])
    const [loadingLocations, setLoadingLocations] = useState(false)
    const [pagination, setPagination] = useState({})
    const navigate = useNavigate()

    const { setAlertSnackbar } = useUtiles()

   

    

    const getLocations = async (filters) => {
        setLoadingLocations(true)
        try {
            const response = await locationsService.getLocations(filters)
            setLocations(response.data.locations)
            setPagination(response.data.pagination)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingLocations(false)
        }
    }


    const getLocationsOptions = async (filters) => {
        setLoadingLocations(true)
        try {
            const response = await locationsService.getLocations(filters)
            setLocationsOptions(response.data.locations)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingLocations(false)
        }
    }

    const [loadingCreateLocation, setLoadingCreateLocation] = useState(false)
    const [location, setLocation] = useState({
        parent: null,
        name: '',
        code: '',
        description: '',
        city: '',
        state: '',
        country: '',
        classification1: null,
        classification2: null,
        enabled: true,
    })

    const resetLocation = () => {
        setLocation({
            parent: null,
            name: '',
            code: '',
            description: '',
            city: '',
            state: '',
            country: '',
            classification1: null,
            classification2: null,
            enabled: true,
        })
    }
    const createLocation = async (data) => {
        setLoadingCreateLocation(true)
        try {
            //obtener solo los id de location, classification1 y classification2
            const data = { ...location, 
                parent: location.parent ? location.parent.id : null, 
                classification1:  location.classification1 ? location.classification1.id : null, 
                classification2: location.classification2 ? location.classification2.id : null  }

            const response = await locationsService.postLocation(data)
            await getLocations()
            resetLocation()
            navigate('/activos/ubicaciones')
            setAlertSnackbar({
                open: true,
                message: 'Ubicación creada correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingCreateLocation(false)
        }
    }

    const [loadingUpdateLocation, setLoadingUpdateLocation] = useState(false)
    const updateLocation = async (data) => {
        setLoadingUpdateLocation(true)
        try {
            //obtener solo los id de location, classification1 y classification2
            const data = { ...location, 
                parent: location.parent ? location.parent.id : null, 
                classification1:  location.classification1 ? location.classification1.id : null, 
                classification2: location.classification2 ? location.classification2.id : null  }
            const response = await locationsService.putLocation(data)
            await getLocations()
            resetLocation()
            navigate('/activos/ubicaciones')
            setAlertSnackbar({
                open: true,
                message: 'Ubicación actualizada correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingUpdateLocation(false)
        }
    }


    const setSelectLocationParent = (location) => {
        setLocation( (prev) => ({ ...prev, parent: location}))
    }

    const setSelectClassification1 = (classification) => {
        setLocation( (prev) => ({ ...prev, classification1: classification}))
    }

    const setSelectClassification2 = (classification) => {
        setLocation( (prev) => ({ ...prev, classification2: classification}))
    }





    const [dataMasive, setDataMasive] = useState(null)
    const [loadingUploadMasive, setLoadingUploadMasive] = useState(false)
    const loadMasiveLocations = async (files) => {
        try{
            setLoadingUploadMasive(true)    
            const file = files[0]
            const reader = new FileReader()

            reader.onload = (event) => {
                const arrayBuffer = event.target.result;
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);
                
                // Procesa los datos aquí
                console.log(data)
                setDataMasive(data)

              };
              
              reader.readAsArrayBuffer(file);
        }catch(error){
            console.log(error)
        }finally{   
            setLoadingUploadMasive(false)
        }
    }


    const [responseMasive, setResponseMasive] = useState(null)
    const [loadingMasive, setLoadingMasive] = useState(false)
    const processMasiveLocations = async () => {
        setLoadingMasive(true)
        try{
            
            const response = await locationsService.postMasiveLocations(dataMasive)
            setResponseMasive(response.data)
            await getLocations()
            console.log(response.data)

            setDataMasive(null)
            setAlertSnackbar({
                open: true,
                message: "Localizaciones procesadas correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al procesar las ubicaciones",
                severity: 'error'
            })
        }finally{
            setLoadingMasive(false)
        }
    }

    const [loadingGetLocationByHash, setLoadingGetLocationByHash] = useState(false)
    const getLocationByHash = async (hash) => {
        setLoadingGetLocationByHash(true)
        try{
            const response = await locationsService.getLocationByHash(hash)
            setLocation(response.data)
            setAlertSnackbar({
                open: true,
                message: "Localización encontrada correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al encontrar la localización",
                severity: 'error'
            })
        }finally{
            setLoadingGetLocationByHash(false)
        }
    }


    /**
     * Eliminar ubicaciones
     */

    const [loadingDeleteLocation, setLoadingDeleteLocation] = useState(false)
    const [selectedLocationsToDelete, setSelectedLocationsToDelete] = useState([])

    // Add getLocationsTree function
    const getLocationsTree = async () => {
        setLoadingLocations(true)
        try {
            const response = await locationsService.getLocationsTree()
            setLocations(response.data)
            console.log(response.data)
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: 'Error al obtener la estructura de ubicaciones',
                severity: 'error'
            })
        } finally {
            setLoadingLocations(false)
        }
    }

    const deleteLocation = async () => {
        setLoadingDeleteLocation(true)
       

        try{    
            const confirm = await Swal.fire({
                title: '¿Está seguro?',
                text: 'Esta acción eliminará las localizaciones seleccionadas',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
            })
    
            if (!confirm.isConfirmed) return

            const response = await locationsService.deleteLocation(selectedLocationsToDelete)
            await getLocations()
            setAlertSnackbar({
                open: true,
                message: response.data.message,
                severity: 'success'
            })
            setSelectedLocationsToDelete([])
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al eliminar las localizaciones",
                severity: 'error'
            })
        }finally{
            setLoadingDeleteLocation(false)
        }
    }



    return (
        <LocationsContext.Provider 
            value={{ 
                locations, 
                loadingLocations, 
                getLocations, 
                getLocationsTree, 
                pagination, 
                setPagination, 
                createLocation, 
                loadingCreateLocation,
                location,
                setLocation,
                setSelectLocationParent,
                setSelectClassification1,
                setSelectClassification2,
                loadingUpdateLocation,
                updateLocation,
                resetLocation,
                loadMasiveLocations,
                processMasiveLocations,
                loadingMasive,
                responseMasive,
                dataMasive,
                loadingUploadMasive,
                getLocationByHash,
                loadingGetLocationByHash,
                setDataMasive,
                setResponseMasive,
                locationsOptions,
                getLocationsOptions,
                deleteLocation,
                loadingDeleteLocation,
                selectedLocationsToDelete,
                setSelectedLocationsToDelete
            }}
        >
            {children}
        </LocationsContext.Provider>
    )
    
}